import { render, staticRenderFns } from "./PaymentsView.vue?vue&type=template&id=6ab92fe1&"
import script from "./PaymentsView.vue?vue&type=script&lang=js&"
export * from "./PaymentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports